const KEY = "viralya-utm";
const FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid"];

export function captureUtm() {
  const p = new URLSearchParams(window.location.search);
  const found = {};
  FIELDS.forEach((f) => { const v = p.get(f); if (v) found[f] = v; });
  if (Object.keys(found).length) {
    localStorage.setItem(KEY, JSON.stringify({ ...getUtm(), ...found, ts: Date.now() }));
  }
}

export function getUtm() {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
}
